import { render } from "./EmergencyAnswerAttachmentForm.vue?vue&type=template&id=a42dd40e&scoped=true&ts=true"
import script from "./EmergencyAnswerAttachmentForm.ts?vue&type=script&lang=ts"
export * from "./EmergencyAnswerAttachmentForm.ts?vue&type=script&lang=ts"

import "./EmergencyAnswerAttachmentForm.scss?vue&type=style&index=0&id=a42dd40e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a42dd40e"]])

export default __exports__